import NewSelectAuto from "../../tenants/NewSelectAuto";

const EmploymentHistoryEdit = ({ postData, setPostData }) => {
  const data = [
    {
      id: 1,
      name: "1"
    },
    {
      id: 2,
      name: "2"
    },
    {
      id: 3,
      name: "3"
    },
     {
      id: 4,
      name: "4"
    }
  ]

  return (
    <>
      <div className="edit-card p-3 ">
           <NewSelectAuto
            disabled={undefined}
            setDisabled={undefined}
            required={true}
            selected={postData?.leaseApplicationTemplateSections?.EmploymentHistory?.requiredRange}
            setSelected={(value) => setPostData({
              ...postData,
              leaseApplicationTemplateSections: {
                ...postData.leaseApplicationTemplateSections,
                EmploymentHistory: {
                  ...postData.leaseApplicationTemplateSections.EmploymentHistory,
                  requiredRange: Number(value),
                },
              },
            })}
            setSelectedOption={undefined}
            selectedOption={undefined}
            data={data}
            title={"Wait till the data fetches"}
            type="option"
            error={false}
            setError={() => { }}
            fromContractor={true}
            label={"Employment History (In Years)"}
            width={"217px"}
          />
          </div>
        
    </>
  );
};

export default EmploymentHistoryEdit;
